import React, {useEffect} from 'react';
import {useAppShell} from "../../app/app-shell/app-shell-context.js";

const getTextContent = (node) => {
    if (node === null || node === undefined || typeof node === "boolean") return "";
    if (typeof node === "string" || typeof node === "number") return String(node);
    if (Array.isArray(node)) return node.map(getTextContent).join("");
    if (React.isValidElement(node)) return getTextContent(node.props.children);

    return "";
};

const TemplateTitle = ({children, className, browserTitle}) => {
    const {collapsed, setPageTitle} = useAppShell();
    const title = getTextContent(children).trim();
    const pageTitle = browserTitle ?? title;

    useEffect(() => {
        if (pageTitle) setPageTitle(pageTitle);
    }, [pageTitle, setPageTitle]);

    return (
        <h2
            className={["text-[#676a6c] text-[24px] whitespace-nowrap overflow-hidden m-0 h-full font-normal leading-[1.2]", className].join(" ")}
            style={{paddingLeft: collapsed ? "120px" : "0px"}}
        >
            {children}
        </h2>
    );
};

export default TemplateTitle;